import React, { SVGProps } from 'react';

const TickIcon = ({ color, ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="12px"
      height="9px"
      viewBox="0 0 12 9"
      version="1.1"
      color="#FFFFFF"
      xmlns="http://www.w3.org/2000/svg"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Trade-Section-Complete"
          transform="translate(-1198.000000, -361.000000)"
          fill={color || 'currentColor'}
          fillRule="nonzero"
        >
          <path
            d="M1199.5544,365.516751 C1199.18249,365.207701 1198.59833,365.224403 1198.24966,365.554057 C1197.90099,365.88371 1197.91983,366.401482 1198.29175,366.710532 L1201.98404,369.778694 C1202.38042,370.10807 1203.01043,370.064256 1203.344,369.684116 L1209.80551,362.320526 C1210.1185,361.963844 1210.04601,361.449804 1209.6436,361.172385 C1209.24119,360.894966 1208.66124,360.959221 1208.34825,361.315902 L1202.50821,367.971258 L1199.5544,365.516751 Z"
            id="Shape"
          />
        </g>
      </g>
    </svg>
  );
};

export default TickIcon;
